import React from "react";
import { dateTimeToStringWithDOW, dateTimeToStringWithSeconds } from "components/Shared/Formatters";
import Icon from "@mui/material/Icon";
import Typography from "@mui/material/Typography";
import { MTable } from "components/Shared";
import moment from "moment-timezone";

export const formatNoteDateCreatedAllSection = note => dateTimeToStringWithSeconds(note.dateCreated);
export const formatNoteDateCreated = note => dateTimeToStringWithDOW(note.dateCreated);
export const formatNoteDateUpdated = note => dateTimeToStringWithDOW(note.dateUpdated);

export const historyTypeToIcon = (t) => {
  switch (t) {
    case 1:
      return "fingerprint"; // touch
    case 2:
      return "comment"; // csNote
    case 3:
      return "feedback"; // Issue
    case 4:
      return "phone"; // Call Log
    case 5:
      return "event_note"; // CaseEvent
    case 6:
      return "assessment"; // Appraisal Status History Log
    case 7:
      return "event_note"; // Appraisal Survey Log (time)
    case 8:
      return "timer"; // CaseTimeLog
    case 9:
      return "gavel"; // Reconsideration
    case 10:
      return "chat_bubble"; // Internal Note
    case 11:
      return "laptop"; // System Touch
    case 12:
      return "announcement"; // External Note
    case 13:
      return "event_available"; // Preferred Appointment
    case 14:
      return "chat_bubble"; // AppraiserNote
  }
};

export const historyTypeToName = (historyType) => {
  switch (historyType) {
    case 1:
      return "Touch";
    case 2:
      return "CS Note";
    case 3:
      return "Issue";
    case 4:
      return "Call Log";
    case 5:
      return "Case Event";
    case 6:
      return "Appraisal Status"; // Appraisal Status History Log
    case 7:
      return "Appraisal Log"; // Appraisal Survey Log (time)
    case 8:
      return "Time Log"; // CaseTimelog
    case 9:
      return "Reconsideration";
    case 10:
      return "Internal Note";
    case 11:
      return "System Touch";
    case 12:
      return "External Note";
    case 13:
      return "Preferred Appointment";
    case 14:
      return "Appraiser Note";
  }
};

export const rawMarkup = value => ({ __html: value });

export const getHistoryTypeDiv = note =>
  <div title={historyTypeToName(note.historyType)} style={{ width: "100%", textAlign: "center" }}>
    <Icon sx={{ color: 'var(--primary-color)' }}>{historyTypeToIcon(note.historyType)}</Icon>
  </div>;

export const getNoteDetails = note =>
  <div className="text-pre-wrap-and-word-break">{note.details}</div>;

export const base64String = "data:image/png;base64";
export const isBase64String = (str) => {
  if (typeof str === "string" && str) {
    let split = str.split(",");
    return split[0] === base64String ? true : false;
  }
};

export const formatNote = (n, note) => {
  if (n.tagName === "IMG") {
    return n.src + "\n";
  } 
  return !note.split("\n").join("").includes(n.textContent) ? n.textContent + "\n" : ""; // make sure no duplicate strings are added 
};

export const getTabbedHistoryTable = (colDefs, data, section, keyProperty) => {
  if (data && data.length) {
    return (<MTable
      className="tabbed-history"
      keyProperty={keyProperty}
      columnDefinitions={colDefs}
      data={data}
    />);
  } else {
    return <Typography>{`No ${section} Entered`}</Typography>;
  }
};

export const filterOnFilterDate = (filterDate, date) => {
  let momentFilter = filterDate && moment(filterDate); // if filter date is undefined then the moment date will represent today, that is bad
  let momentDate = date && moment(date);
  if (!momentFilter?.isValid()) return true; // if theres no filter show everything
  if (!momentDate?.isValid()) return false; // if theres a valid filter and the date passed in is invalid, dont show it

  let comparisonFormat = "MM-DD-YYYY";

  return momentFilter.format(comparisonFormat) === momentDate.format(comparisonFormat);
};
